import { useContext } from "react";
import { NawyPassportContext } from "@/modules/common/context/nawy-passport.provider";
import { useLeadContext } from "@/modules/lead-page/context/lead-page.context";
import { userHasPermission } from "@/modules/common/utils";
import { PermissionLevel, PermissionsEnum } from "@/modules/common/types";
import PermissionGuard from "@/modules/common/components/wrappers/permission-guard";
import ResponsiveModal from "@/modules/common/components/ui-kit/modals/responsive-modal";
import EditEmail from "@/modules/lead-page/components/lead-info/edit-fields/email";
import LeadInfoField from "@/modules/lead-page/new/components/lead-info-field";
import useLeadInfo from "@/modules/lead-page/hooks/lead-info/lead-info.hook";
import FieldWrapper from "@/modules/lead-page/new/components/sidebar/fields/field-wrapper";

const EmailField = () => {
  const { email, lead, isLoading, isError, handleConfirmUpdate } =
    useLeadInfo();
  const { permissions: currentUserPermissions } =
    useContext(NawyPassportContext);
  const { isAssignedAgent } = useLeadContext();

  return (
    <LeadInfoField
      editable={
        userHasPermission(
          {
            name: PermissionsEnum.CUSTOMER_EMAIL,
            level: PermissionLevel.WRITE,
          },
          currentUserPermissions
        ) || isAssignedAgent
      }
      sxInnerBox={{
        justifyContent: "space-between",
      }}
      content={email.value || "Not Set"}
      setEditModalOpen={email.setEditEmailModalOpen}
      editModalOpen={email.editEmailModalOpen}
      editModal={
        <PermissionGuard
          permissions={[
            {
              name: PermissionsEnum.CUSTOMER_EMAIL,
              level: PermissionLevel.WRITE,
            },
            {
              name: PermissionsEnum.ASSIGNED_AGENT,
              level: PermissionLevel.ALL,
            },
          ]}
        >
          <ResponsiveModal
            open={email.editEmailModalOpen}
            onClose={() => {
              email.setEditEmailModalOpen(false);
              email.resetFormatError();
              email.setState(lead?.data?.lead?.email || null);
            }}
            title="Edit Email"
            confirmButtonText="Save"
            cancelButtonText="Cancel"
            onConfirm={() => {
              if (email.handleFormatError()) {
                handleConfirmUpdate({
                  emails: {
                    email: email.state ?? null,
                    default: true,
                  },
                });
              }
            }}
            isLoading={isLoading}
            isConfirmDisabled={email.formatError || !email.state}
            snapPoints={[1]}
          >
            <FieldWrapper>
              <EditEmail
                autoFocus
                email={email}
                lead={lead}
                isError={isError}
              />
            </FieldWrapper>
          </ResponsiveModal>
        </PermissionGuard>
      }
    />
  );
};

export default EmailField;
